import React from 'react';
import InputCalendarRangeComponent from '../../components/inputs/InputCalendarRangeComponent';
import {t} from 'i18next';
import PropTypes from 'prop-types';
import {ViewMode} from '../../model/enum/ViewMode';
import InputCheckboxComponent from '../../components/inputs/InputCheckboxComponent';
import InputCalendarComponent from '../../components/inputs/InputCalendarComponent';
import Constants from '../../utils/constants';
import StringUtils from '../../utils/StringUtils';
import InputTextComponent from '../../components/inputs/InputTextComponent';

export const DelegationDietStep = ({element, validator, viewMode, handleChange, setFullBoard}) => {
    const renderDestination = (destination, rowIndex) => {
        return (
            <div className='row'>
                <div className='col-12'>
                    <InputCheckboxComponent
                        labelOnRight={true}
                        id={`meals-` + rowIndex}
                        name='meals'
                        colClass='col-4'
                        label={rowIndex + 1 + ` - Pełne wyżywienie ${isForeign() ? ' - ' + destination.country.name : ''}`}
                        value={destination.meals === null}
                        validator={validator}
                        validators='not_required'
                        stateField=''
                        viewMode={viewMode === ViewMode.VIEW ? ViewMode.EDIT : viewMode}
                        disabled={viewMode === ViewMode.VIEW}
                        onChange={(a, b, c, d, e) => {
                            setFullBoard(c.checked, destination.id);
                        }}
                    />
                </div>
                {destination.meals !== null && (
                    <React.Fragment>
                        <InputTextComponent
                            id={`breakfasts-` + rowIndex}
                            name='breakfasts'
                            label={t('delegation.breakfasts')}
                            value={destination?.meals?.breakfasts}
                            stateField={`element.destinations[${rowIndex}].meals`}
                            onChange={handleChange}
                            disabled={viewMode === 'VIEW'}
                            viewMode={viewMode === 'VIEW' ? 'EDIT' : viewMode}
                            validator={validator}
                            validators='required|numeric'
                        />
                        <InputTextComponent
                            id={`dinners-` + rowIndex}
                            name='dinners'
                            label={t('delegation.dinners')}
                            value={destination?.meals?.dinners}
                            stateField={`element.destinations[${rowIndex}].meals`}
                            onChange={handleChange}
                            disabled={viewMode === 'VIEW'}
                            viewMode={viewMode === 'VIEW' ? 'EDIT' : viewMode}
                            validator={validator}
                            validators='required|numeric'
                        />
                        <InputTextComponent
                            id={`suppers-` + rowIndex}
                            name='suppers'
                            label={t('delegation.suppers')}
                            value={destination?.meals?.suppers}
                            stateField={`element.destinations[${rowIndex}].meals`}
                            onChange={handleChange}
                            disabled={viewMode === 'VIEW'}
                            viewMode={viewMode === 'VIEW' ? 'EDIT' : viewMode}
                            validator={validator}
                            validators='required|numeric'
                        />
                    </React.Fragment>
                )}
                <div className='col-12'>
                    <InputCalendarComponent
                        id={`startDate-${rowIndex}`}
                        colClass='col-lg-4'
                        name='startDate'
                        label={'Data przekroczenia granicy kraju - ' + destination.country.name}
                        dateFormatMoment={Constants.DATE_TIME_FORMAT_WITHOUT_SEC}
                        placeholder='DD-MM-YYYY HH:mm'
                        value={StringUtils.isString(destination.startDate) ? new Date(destination.startDate) : destination.startDate}
                        onChange={handleChange}
                        viewMode={viewMode}
                        validator={validator}
                        showTime
                        showSeconds={false}
                        validators={`between_start_end_dates`}
                        stateField={`element.destinations[${rowIndex}]`}
                        showLabel={true}
                        showIcon
                    />
                </div>
            </div>
        );
    };

    const renderDestinations = () => {
        return element.destinations.map((destination, index) => {
            return (
                <div className='mt-4 mb-3' key={'destination-key-' + index}>
                    {renderDestination(destination, index)}
                </div>
            );
        });
    };

    const isForeign = () => {
        return element.type?.enumValue === 'FOREIGN';
    };

    return (
        <div className='row'>
            <InputCalendarRangeComponent
                id='date-diet'
                idFrom='startDate'
                nameFrom='startDate'
                idTo='endDate'
                nameTo='endDate'
                showTime={true}
                dateFormatMoment={Constants.DATE_TIME_FORMAT}
                labelFrom={t('delegation.details.startDate')}
                labelTo={t('delegation.details.endDate')}
                colClass={'col-12 mb-3'}
                placeholderFrom='DD-MM-YYYY HH:mm'
                placeholderTo='DD-MM-YYYY HH:mm'
                from={element.startDate}
                to={element.endDate}
                validator={validator}
                onChange={handleChange}
                viewMode={viewMode}
                showIcon={true}
                validators={'required'}
                validatorsToType={''}
            />
            <InputCheckboxComponent
                labelOnRight={true}
                id={`meals`}
                name='meals'
                label={`Pełne wyżywienie ${isForeign() ? ' - Polska' : ''}`}
                value={element.meals === null}
                validator={validator}
                colClass='col-12 mt-3'
                validators='not_required'
                stateField=''
                viewMode={viewMode === ViewMode.VIEW ? ViewMode.EDIT : viewMode}
                disabled={viewMode === ViewMode.VIEW}
                onChange={(a, b, c, d, e) => {
                    setFullBoard(c.checked);
                }}
            />

            {element.meals !== null && (
                <React.Fragment>
                    <InputTextComponent
                        id={`breakfasts`}
                        name='breakfasts'
                        label={t('delegation.breakfasts')}
                        value={element?.meals?.breakfasts}
                        stateField={`element.meals`}
                        onChange={handleChange}
                        disabled={viewMode === 'VIEW'}
                        viewMode={viewMode === 'VIEW' ? 'EDIT' : viewMode}
                        validator={validator}
                        validators='required|numeric'
                    />
                    <InputTextComponent
                        id={`dinners`}
                        name='dinners'
                        label={t('delegation.dinners')}
                        value={element?.meals?.dinners}
                        stateField={`element.meals`}
                        onChange={handleChange}
                        disabled={viewMode === 'VIEW'}
                        viewMode={viewMode === 'VIEW' ? 'EDIT' : viewMode}
                        validator={validator}
                        validators='required|numeric'
                    />
                    <InputTextComponent
                        id={`suppers`}
                        name='suppers'
                        label={t('delegation.suppers')}
                        value={element?.meals?.suppers}
                        stateField={`element.meals`}
                        onChange={handleChange}
                        disabled={viewMode === 'VIEW'}
                        viewMode={viewMode === 'VIEW' ? 'EDIT' : viewMode}
                        validator={validator}
                        validators='required|numeric'
                    />
                </React.Fragment>
            )}
            {isForeign() && (
                <React.Fragment>
                    <InputCalendarComponent
                        id='crossPolishBorderDate'
                        name='crossPolishBorderDate'
                        label='Data przekrocznia granicy Polski (wyjazd) - Data pierwszego miejsca docelowego'
                        colClass={'col-xl-6 col-lg-6 col-md-6 col-sm-12 mb-2'}
                        onChange={handleChange}
                        viewMode={viewMode === ViewMode.EDIT ? ViewMode.VIEW : viewMode}
                        disabled={viewMode !== ViewMode.VIEW}
                        value={
                            StringUtils.isString(element?.destinations[0]?.startDate)
                                ? new Date(element?.destinations[0]?.startDate)
                                : element?.destinations[0]?.startDate
                        }
                        showIcon
                        showClear
                        placeholder='DD-MM-YYYY HH:mm'
                        showTime={true}
                        dateFormatMoment={Constants.DATE_TIME_FORMAT_WITHOUT_SEC}
                        propCustomValue={true}
                    />

                    <InputCalendarComponent
                        id='crossPolishBorderReturnDate'
                        name='crossPolishBorderReturnDate'
                        label='Data przekrocznia granicy Polski (wjazd)'
                        colClass={'col-xl-6 col-lg-6 col-md-6 col-sm-12 mb-2'}
                        onChange={handleChange}
                        viewMode={viewMode}
                        validator={validator}
                        value={
                            StringUtils.isString(element?.crossPolishBorderReturnDate)
                                ? new Date(element?.crossPolishBorderReturnDate)
                                : element?.crossPolishBorderReturnDate
                        }
                        showIcon
                        showClear
                        placeholder='DD-MM-YYYY HH:mm'
                        showTime={true}
                        validators={'between_start_end_dates'}
                        dateFormatMoment={Constants.DATE_TIME_FORMAT_WITHOUT_SEC}
                        propCustomValue={true}
                    />
                </React.Fragment>
            )}
            {isForeign() && renderDestinations()}
        </div>
    );
};

DelegationDietStep.defaultProps = {
    handleChange: undefined,
    viewMode: ViewMode.VIEW,
    element: undefined,
    validator: undefined,
};

DelegationDietStep.propTypes = {
    handleChange: PropTypes.func.isRequired,
    viewMode: PropTypes.string,
    element: PropTypes.object,
    validator: PropTypes.object,
};

export default DelegationDietStep;
